

import { create } from 'zustand';
import { subscribeWithSelector } from 'zustand/middleware';
import dayjs from 'dayjs';
import { isMobile } from 'react-device-detect';



import manageService from '@app/service/manageService';
import notificationService from '@app/service/notificationService';
import userStore from './userStore';
import MobileInquiryPageStore from '@app/pages/mobile/inquiry/MobileInquiryPageStore';
import { isLooseEqual } from '@app/utils/equality';


const debug = false;
const size = 20;
const notificationStore = create(
  subscribeWithSelector(
    (set, get) => ({
      openNotification: false,
      notifications: [],
      badged: false,
      page: 0,
      totalCount: 0,
      standardNotiId: null,
      incomeNotification: null,
      incomeReservationNoti: null, // type이 RESERVATION 으로 들어온 알림( 객실 문의 목록, 상세 갱신을 위함)
      checkedChattingRoomId: null, //채팅 방 읽음 처리시 해당 ID값, (ID값 변경 => 클라이언트 페이지에서 갱신)
      setOpenNotification: (open) => {
        set({ openNotification: open, badged: false });
      },
      setNotifications: (notifications) => {
        set({ notifications: notifications });
      },
      checkNotification: (notiId) => {
        const userNo = userStore?.getState()?.myInfo?.userNo;
        if (!userNo) return;
        notificationService.checkNotification(notiId, userNo).then((res) => {
          const notifications = get().notifications;
          const index = notifications.findIndex((item) => item.id === notiId);
          if (index !== -1) {
            notifications[index].isChecked = true;
          }

          set({ notifications: notifications });
        });
      },
      checkNotificationGroup: (lastChatSeq, rezId) => {
        const hotelId = userStore?.getState()?.hotelInfo?.id;
        const userNo = userStore?.getState()?.myInfo?.userNo;
        if (!userNo) return;
        notificationService
          .checkNotificationGroup({ hotelId, lastChatSeq, rezId, userNo })
          .then((res) => {
            // alert(test);
            set({ checkedChattingRoomId: rezId });
          });
      },
      setCheckedChattingRoomId: (id) => {
        set({ checkedChattingRoomId: id });
      },
      nextNotificationsPage: () => {
        const userNo = userStore?.getState()?.myInfo?.userNo;
        const currentNotifications = get().notifications;
        const totalCount = get().totalCount;
        if (currentNotifications.length >= totalCount) {
          console.log('[notifications] 이미 마지막 페이지 입니다.');
          return;
        }
        if (!userNo) return;
        const nextPage = get().page + 1;
        notificationService
          .getMyNotificationList({
            fromDate: dayjs().subtract(7, 'days').format('YYYYMMDD'),
            toDate: dayjs().format('YYYYMMDD'),
            lastId: get().standardNotiId,
            page: nextPage,
            size,
            sort: 'id,DESC',
            userNo: userNo,
          })
          .then((res) => {
            notificationStore.setState({
              notifications: [...currentNotifications, ...res?.data?.data],
              page: nextPage,
              totalCount: res.data.meta.totalCount,
            });
          })
          .catch((e) => console.log(e));
      },
      incomeNoti: (noti) => {
        console.log(noti);
        const openNotification = get().openNotification;
        set({ incomeNotification: noti });
        if (!openNotification) {
          if (
            isLooseEqual(noti.type, 'REZ') &&
            isLooseEqual(noti.pushReserveInfo?.type, 'RESERVATION')
          ) {
            const userNo = userStore?.getState()?.myInfo?.userNo;
            const findIndex = noti.pushReserveInfo?.targetUesrNos.findIndex(
              (user, i) => {
                return isLooseEqual(user, userNo);
              },
            );
            if (findIndex > -1) {
              set({ badged: true });
            }
          } else {
            set({ badged: true });
          }
        } else {
          let newCurrentNotifications = [...get().notifications];
          newCurrentNotifications.unshift(noti);
          set({ notifications: newCurrentNotifications });
        }
        if (isLooseEqual(noti?.pushReserveInfo?.type, 'RESERVATION'))
          set({ incomeReservationNoti: noti });
      },
      cleanIncomeNoti: () => {
        set({ incomeNotification: null });
      },
      resetIncomeReservationNoti: () => {
        set({ incomeReservationNoti: null });
      },
      getNotifications: () => {
        const userNo = userStore?.getState()?.myInfo?.userNo;
        if (!userNo) return;
        notificationService
          .getMyNotificationList({
            fromDate: dayjs().subtract(7, 'days').format('YYYYMMDD'),
            toDate: dayjs().format('YYYYMMDD'),
            page: 0,
            size,
            sort: 'id,DESC',
            userNo: userNo,
          })
          .then((res) => {
            set({
              notifications: res?.data?.data,
              page: 0,
              totalCount: res.data.meta.totalCount,
            });
            if (res?.data?.data.length > 0) {
              set({
                standardNotiId: res?.data?.data[0].id,
              });
            }
          })
          .catch((e) => console.log(e));
      },
    }),
    { name: 'occHotelNotifications', version: 0 },
  ),
);

notificationStore.subscribe(
  (state) => state.openNotification,
  (openNotification) => {
    debug &&
      console.log('openNotification has been changed: ', openNotification);

    const userNo = userStore?.getState()?.myInfo?.userNo;
    if (!userNo) return;

    if (openNotification) {
      notificationService
        .getMyNotificationList({
          fromDate: dayjs().subtract(7, 'days').format('YYYYMMDD'),
          toDate: dayjs().format('YYYYMMDD'),
          page: 0,
          size,
          sort: 'id,DESC',
          userNo: userNo,
        })
        .then((res) => {
          notificationStore.setState({
            notifications: res?.data?.data,
            page: 0,
            totalCount: res.data.meta.totalCount,
          });
          if (res?.data?.data.length > 0) {
            // CSV-02: 여러 호텔을 쓰면 작업 호텔별 키(호텔이 1개면 기존 키)
            localStorage.setItem(
              userStore.getState().lastCheckNotificationKey(),
              res?.data?.data[0].id,
            );
            notificationStore.setState({
              standardNotiId: res?.data?.data[0].id,
            });
          }
        })
        .catch((e) => console.log(e));
      return;
    }
  },
);

notificationStore.subscribe(
  (state) => state.incomeReservationNoti,
  (incomeReservationNoti) => {
    // 모바일 일 때 incomeReservationNoti 변경 시 inquiryList 갱신
    if (!isMobile || !incomeReservationNoti) return;
    const inquiryList = MobileInquiryPageStore.getState().inquiryList;
    if (inquiryList && inquiryList?.length === 0) return;
    const findInquiry = inquiryList?.find(
      (inquiry) =>
        isLooseEqual(inquiry.id, incomeReservationNoti?.pushReserveInfo?.contentsId),
    );
    // findInquiry가 있으면 해당 id 조회 후 초기화 , 없으면 그냥 초기화
    if (!findInquiry)
      return notificationStore.setState({ incomeReservationNoti: null });
    else {
      manageService
        .getReservationInfo(findInquiry.id)
        .then((res) => {
          const data = res.data.data;
          const newList = inquiryList.map((inquiry) => {
            if (isLooseEqual(inquiry.id, data.id))
              return { ...data, chatStatus: inquiry.chatStatus };
            else return inquiry;
          });
          MobileInquiryPageStore.setState({ inquiryList: newList });
          notificationStore.setState({ incomeReservationNoti: null });
        })
        .catch((e) => console.log('e', e));
    }
  },
);
export default notificationStore;
